var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 6,
    fill: "#88D4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 6,
    stroke: "#88D4FF",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1546_67326",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 32,
    height: 32
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1546_67326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 32V29.3333H10.6667V10.6667C10.6667 9.93333 10.9278 9.30556 11.45 8.78333C11.9722 8.26111 12.6 8 13.3333 8H26.6667C27.4 8 28.0278 8.26111 28.55 8.78333C29.0722 9.30556 29.3333 9.93333 29.3333 10.6667V29.3333H32V32H8ZM26.6667 29.3333V10.6667H13.3333V29.3333H26.6667ZM24 21.3333C24.3778 21.3333 24.6944 21.2056 24.95 20.95C25.2056 20.6944 25.3333 20.3778 25.3333 20C25.3333 19.6222 25.2056 19.3056 24.95 19.05C24.6944 18.7944 24.3778 18.6667 24 18.6667C23.6222 18.6667 23.3056 18.7944 23.05 19.05C22.7944 19.3056 22.6667 19.6222 22.6667 20C22.6667 20.3778 22.7944 20.6944 23.05 20.95C23.3056 21.2056 23.6222 21.3333 24 21.3333Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDoor);
export default __webpack_public_path__ + "static/media/ActiveDoor.e50d89f7723567fe3ae68a4f664f59f5.svg";
export { ForwardRef as ReactComponent };